
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Sometimes referred to as site-structure, considering that the components or elements we address are content-independent.`}</p>
    <p>{`At this point we refer to an element as the totality of the multiple components making up the header, footer, search or other universal components present at all times throughout the site.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;